import styled from "@emotion/styled";
import { useRoutes } from "../state/RouteContext";
import { trackEvent } from "../tracking/utils";
import { FaWhatsapp } from "react-icons/fa";

const SITE_URL = "https://www.hebiktegenwind.nl";

const S = {
  Button: styled.button`
    background: rgba(255, 255, 255, 0.12);
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 8px 12px;
    font-size: 13px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    align-self: flex-start;
    transition: background 120ms ease;

    &:hover {
      background: rgba(255, 255, 255, 0.25);
    }
  `,
};

const buildShareUrl = (): string => {
  const { pathname, search } = window.location;
  return `${SITE_URL}${pathname}${search}`;
};

const buildShareText = (fromText?: string, toText?: string): string => {
  if (fromText && toText) {
    return `Check mijn tegenwind van ${fromText} naar ${toText}: `;
  }
  return `Check de tegenwind voor jouw fietsroute: `;
};

export function ShareButton({className}: {className?: string}) {
  const { journey } = useRoutes();
  const from = journey?.from?.text;
  const to = journey?.to?.text;

  if (!from || !to) return null;

  const handleShare = async () => {
    const url = buildShareUrl();
    const text = buildShareText(from, to);
    trackEvent("Share Clicked", { from, to });

    const nav = navigator as Navigator & {
      share?: (data: ShareData) => Promise<void>;
    };

    if (nav.share) {
      try {
        await nav.share({ title: "Heb ik tegenwind?", text, url });
        return;
      } catch {
        // User cancelled or API failed — fall through to WhatsApp.
      }
    }
    const waText = `${text}${url}`;
    window.open(
      `https://wa.me/?text=${encodeURIComponent(waText)}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <S.Button onClick={handleShare} type="button" className={className}>
      <FaWhatsapp />
      Deel route
    </S.Button>
  );
}
